<div class="tenant-dashboard">
  <h2 class="page-title">Select a Tenant</h2>
  <p class="page-subtitle">Choose tenant to manage and configure</p>

  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="search-box">
      <i class="bi bi-search"></i>
      <input type="text" placeholder="Search tenant..." />
    </div>
    <div class="view-toggle">
      <button type="button" [class.active]="isGridView" (click)="setView(true)">
        <i class="bi bi-grid-3x3-gap-fill"></i>
      </button>
      <button type="button" [class.active]="!isGridView" (click)="setView(false)">
        <i class="bi bi-list-ul"></i>
      </button>
    </div>
  </div>

  @if (loading) {
    <div class="loading-container">
      <app-loader />
    </div>
  } @else {
    <div class="tenant-list" [class.list-view]="!isGridView">
      @for (t of tenants; track t.tenant_uid) {
        <div class="tenant-card" (click)="openTenant(t)">
          <div class="tenant-card-top">
            <div class="tenant-icon">
              <i class="bi bi-building"></i>
            </div>
            <span class="tenant-name">{{ t.name }}</span>
            <i class="bi bi-chevron-right tenant-arrow"></i>
          </div>
          <div class="tenant-card-stats">
            <div>
              <div class="stat-value">{{ t.active_users_count }}</div>
              <div class="stat-label">Active Users</div>
            </div>
            <div>
              <div class="stat-value">{{ t.assigned_services_count }}</div>
              <div class="stat-label">Services</div>
            </div>
          </div>
          <div class="tenant-card-footer">
            <div class="stat-label">Last Activity</div>
            <div class="last-activity">{{ t.last_activity ?? '—' }}</div>
          </div>
        </div>
      }
    </div>
  }
</div>
